import useAuthStore from '../store/authStore';
import { useEffect, useState } from 'react';
import { formatLastLoggedInDate, isUserLikelyOnline } from '../lib/dateParse';
import { FiSun, FiMoon } from 'react-icons/fi';

const Sidebar = (props) => {
  const { allUserDetails, fetchAllUserDetails, sidebarStatus } = useAuthStore(
    (state) => ({
      allUserDetails: state.allUserDetails,
      fetchAllUserDetails: state.fetchAllUserDetails,
      sidebarStatus: state.sidebarStatus,
    })
  );

  const themeSwitcher = (e) => {
    e.preventDefault();
    document.querySelector('html').classList.toggle('dark');
    localStorage.setItem('darkmode_enabled', !darkModeEnabled);
    setDarkModeEnabled(!darkModeEnabled);
  };

  const [darkModeEnabled, setDarkModeEnabled] = useState(
    localStorage.getItem('darkmode_enabled') === 'true'
  );

  useEffect(() => {
    fetchAllUserDetails();
  }, [fetchAllUserDetails]);

  return (
    <aside
      ref={props.passRef}
      className={sidebarStatus ? 'active-sidebar' : ''}
    >
      <h4>
        <span className="material-icons">timer</span> Last Active (Users)
      </h4>
      <ul>
        {allUserDetails &&
          allUserDetails.map((u) => {
            return (
              <li key={u.id}>
                <div
                  className={`user-pic ${
                    isUserLikelyOnline(u.lastActive?.seconds * 1000)
                      ? 'is-online'
                      : ''
                  }`}
                >
                  <img src={u.avatar} alt="" />
                </div>
                <div>
                  <h5>{u.displayName}</h5>
                  <time>
                    <span className="material-icons">schedule</span>{' '}
                    {u?.lastActive &&
                      formatLastLoggedInDate(
                        new Date(u.lastActive?.seconds * 1000)
                      )}
                  </time>
                </div>
              </li>
            );
          })}
      </ul>

      <button onClick={themeSwitcher} className="theme-switcher">
        {darkModeEnabled ? <FiMoon /> : <FiSun />}
      </button>
    </aside>
  );
};

export default Sidebar;
